// src/components/Header.tsx
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuthApi } from '../hooks/use-auth-api';

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [megaMenuOpen, setMegaMenuOpen] = useState(false);
  const { user, isAuthenticated, isLoading, logout, refresh } = useAuthApi();
  const location = useLocation();
  const isAdmin = user?.role === 'admin' || user?.role === 'manager';

  useEffect(() => {
    refresh();
  }, [location.pathname]);

  useEffect(() => {
    refresh();
  }, []);

  if (isLoading) {
    return (
      <header className="header" id="header">
        <div className="header__main">
          <div className="header__sidebar">
            <Link to="/" className="header__logo">
              <span className="header__logo-text">سبزه میدون</span>
            </Link>
          </div>
        </div>
      </header>
    );
  }

  return (
    <header className="header" id="header">
      <div className="header__main">
        <nav className="header__nav">
          <div className="header__nav-inner">
            {/* ── لینک‌های اصلی ────────────────────────── */}
            <Link to="/" className={`header__nav-link ${location.pathname === '/' ? 'active' : ''}`}>
              خانه
            </Link>

            <div
              className={`header__nav-link header__nav-link--mega ${megaMenuOpen ? 'open' : ''}`}
              onMouseEnter={() => setMegaMenuOpen(true)}
              onMouseLeave={() => setMegaMenuOpen(false)}
            >
              محصولات
            </div>

            <Link to="/shop" className={`header__nav-link ${location.pathname === '/shop' ? 'active' : ''}`}>
              فروشگاه
            </Link>

            {/* ── اطلاع‌رسانی (جدید) ────────────────────── */}
            <Link
              to="/announcements"
              className={`header__nav-link ${location.pathname.startsWith('/announcements') ? 'active' : ''}`}
            >
              📢 اطلاع‌رسانی
            </Link>

            <Link to="/articles" className={`header__nav-link ${location.pathname === '/articles' ? 'active' : ''}`}>
              وبلاگ
            </Link>

            <Link to="/experiences" className={`header__nav-link ${location.pathname === '/experiences' ? 'active' : ''}`}>
              تجارب
            </Link>

            <Link to="/advertisements" className={`header__nav-link ${location.pathname === '/advertisements' ? 'active' : ''}`}>
              آگهی‌ها
            </Link>

            <Link to="/transport" className={`header__nav-link ${location.pathname === '/transport' ? 'active' : ''}`}>
              بار و ماشین
            </Link>

            <Link to="/contact" className={`header__nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>
              تماس
            </Link>

            {/* ── بخش کاربری ────────────────────────────── */}
            {isAuthenticated ? (
              <>
                {isAdmin && (
                  <Link to="/admin/dashboard" className={`header__nav-link ${location.pathname.startsWith('/admin') ? 'active' : ''}`}>
                    🛠️ مدیریت
                  </Link>
                )}
                <div className="header__user-menu">
                  <button className="header__user-trigger">
                    👤 {user?.name || 'کاربر'}
                  </button>
                  <div className="header__user-dropdown">
                    <Link to="/profile">📋 پروفایل من</Link>
                    {isAdmin && <Link to="/admin/dashboard">📊 داشبورد مدیریت</Link>}
                    <a href="#" onClick={(e) => { e.preventDefault(); logout(); }}>🚪 خروج</a>
                  </div>
                </div>
              </>
            ) : (
              <Link to="/login" className="header__nav-link" style={{ color: 'var(--primary)', fontWeight: 700 }}>
                🔑 ورود
              </Link>
            )}

            <button className="header__hamburger" onClick={() => setMenuOpen(!menuOpen)}>
              <span></span><span></span><span></span>
            </button>
          </div>
        </nav>

        <div className="header__sidebar">
          <Link to="/" className="header__logo">
            <span className="header__logo-text">سبزه میدون</span>
          </Link>
          <button className="header__support-btn">پشتیبانی</button>
          <div className="header__sidebar-actions">
            <button className="header__sidebar-icon">👤</button>
            <button className="header__sidebar-icon">🛒</button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;